
import { defineComponent, PropType, ref } from 'vue'
import loading from '../common/loading.vue'

export default defineComponent({
  components: { loading },
  props: {
    nft: {
      type: Object as PropType<{
        image: string;
        name: string;
      }>,
      required: true
    }
  },
  setup () {
    const imageLoadFinish = ref(false)

    function imageLoad () {
      imageLoadFinish.value = true
    }

    return {
      imageLoad,
      imageLoadFinish
    }
  }
})
